import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@scentregroup/shared/link';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import CallToAction from "@scentregroup/ui/components/call-to-action";
import ExternalLink from '../external-link';
import ResponsiveImage from '../responsive-image';
import Trackable from '../trackable';
import { trackingActions, trackingTypes } from '../../constants';
import MemberExclusiveLabel from '../member-exclusive-label';
import { isMemberExclusive } from '../../helpers/is-member-exclusive';
import styles from './whats-on-list-item.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const isEvent = item => Boolean(item.time);
const isBookable = item => Boolean(item.bookingUrl);
const WhatsOnListItem = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({}, item.analyticsMetadata), {}, {
    trackingAction: trackingActions.viewPromotion,
    type: trackingTypes.promotion,
    "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_Trackable",
    children: /*#__PURE__*/_jsxs("li", {
      className: classNames(styles.item, styles.evolved),
      "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_Trackable_li",
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.infoSection,
        "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_li_div",
        children: [/*#__PURE__*/_jsx(Link, {
          to: item.slug,
          className: styles.itemAction,
          "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_Link",
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_Link_div",
            children: [/*#__PURE__*/_jsx(Heading, {
              type: "extrasmall",
              className: styles.heading,
              "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_Heading",
              children: item.name
            }), /*#__PURE__*/_jsx(Paragraph, {
              type: "medium",
              className: styles.details,
              "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_Paragraph",
              children: isEvent(item) ? item.time : item.dates
            }), /*#__PURE__*/_jsxs(Paragraph, {
              type: "medium",
              className: styles.details,
              "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_Paragraph_7",
              children: [isEvent(item) && item.price ? "".concat(item.price, " \u2022 ") : '', item.location]
            }), /*#__PURE__*/_jsx(MemberExclusiveLabel, {
              sx: {
                width: '91px',
                marginTop: 'spacing-md'
              },
              display: isMemberExclusive(item.highlightAttribute),
              option: "small",
              "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_MemberExclusiveLabel"
            }), /*#__PURE__*/_jsx(_Fragment, {})]
          })
        }), isBookable(item) ? /*#__PURE__*/_jsx("div", {
          className: styles.extraActions,
          "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div",
          children: /*#__PURE__*/_jsx(Paragraph, {
            type: "medium",
            "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_div_Paragraph",
            children: /*#__PURE__*/_jsx(CallToAction, {
              className: styles.bookingButton,
              element: ExternalLink,
              url: item.bookingUrl,
              "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_Paragraph_CallToAction",
              children: "Book now"
            })
          })
        }) : undefined]
      }), /*#__PURE__*/_jsx(Link, {
        to: item.slug,
        className: styles.imageContainer,
        "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_li_Link",
        children: /*#__PURE__*/_jsx(ResponsiveImage, {
          alt: item.image.description,
          desktopImageUrl: item.image.sourceDesktop,
          mobileImageUrl: item.image.sourceMobile,
          mobileRatio: "square",
          desktopRatio: "square",
          numberOfItems: 3,
          "data-id": "whats-on-list_whats-on-list-item_WhatsOnListItem_Link_ResponsiveImage"
        })
      })]
    })
  }));
};
const ImagePropType = PropTypes.shape({
  sourceDesktop: PropTypes.string.isRequired,
  sourceMobile: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
});
export const EventPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  bookingUrl: PropTypes.string,
  image: ImagePropType.isRequired
});
export const OfferPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  dates: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  image: ImagePropType.isRequired
});
export const ItemPropType = PropTypes.oneOfType([EventPropType, OfferPropType]);
export default WhatsOnListItem;